import { parseNumber, formatNumber } from 'libphonenumber-js'
import { BaseError } from '../errors';

export class PhoneNumberHelper {
  static formatNumber(number, defaultCountry) {
    const parsed = parseNumber(number, defaultCountry);
    if (!parsed || !parsed.country || !parsed.phone) {
      throw new BaseError('Invalid phone number');
    }
    //console.log('parsed number:', parsed);
    return formatNumber(parsed, 'E.164');
  }

  static formatNumberV2(number, defaultCountry) {
    const parsed = parseNumber(number, defaultCountry);
    if (!parsed || !parsed.country || !parsed.phone) {
      return null
    }
    //console.log('parsed number:', parsed);
    return formatNumber(parsed, 'E.164');
  }
}


// WEBPACK FOOTER //
// ./src/common/helpers/PhoneNumberHelper.js